import * as React from 'react';
import { useRef, useState, useEffect } from 'react';
import request from 'src/utils/request';
import { NavLink } from 'react-router-dom';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
  Modal,
  Backdrop,
  Grid,
  Tooltip
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';






const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  textAlign: 'center',
  borderRadius: '8px',
  p: 5
};



function HeaderAdminbox({handleMenuClose}) {
    const navigate = useNavigate();
    const location = useLocation();
  const switchAdmin = async (type) => {
          localStorage.setItem('admin_window',type);
          handleMenuClose();
          const { pathname } = location;
          window.location.href=pathname;
         
  };



  

  return (
    <>
 <Modal
        open={true}
        onClose={handleMenuClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        
      >
        <Box sx={style}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >

            <Grid item xs={6} onClick={() => switchAdmin('SystemAdmin')}>
              <div className="category-card">
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 1 }}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid style={{marginTop:'.5vw'}}>
                   <SettingsSuggestIcon style={{color:'#0954ae',fontSize:'2.6rem'}}/>
                  </Grid>
                  <Grid style={{marginTop:'.5vw'}}>
                    <h4>System Admin</h4>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={6} onClick={() => switchAdmin('insuranceAdmin')}>
              <div className="category-card">
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid style={{marginTop:'.5vw'}}>
                   <EnhancedEncryptionIcon style={{color:'#0954ae',fontSize:'2.6rem'}} />
                  </Grid>
                  <Grid style={{marginTop:'.5vw'}}>
                    <h4>Insurance Admin</h4>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}

export default HeaderAdminbox;
